<template>
  <div>
    <nav-bar></nav-bar>
    <div id="workWithUsPage" class="container-fluid ">
      <v-form ref="form" class="padding px-5 ">
        <fieldset class="field-border p-2 " >
          <legend class="col-auto px-2 primary-color-text text-center">{{ $getText("PERSONAL_INFORMATION")}}</legend>
          <div class="row">
            <div class="col-12 col-md-4 py-1 " >
              <v-text-field
                  v-model="NameAndFamily"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""
                  :label= "$getText('FULL_NAME')"
                  outlined
                  >
              </v-text-field>
            </div>
            <div class="col-12 col-md-4 py-1">
              <v-text-field
                  v-model="FatherName"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""
                  drk
                  :label="$getText('FATHER')"
                  outlined>
              </v-text-field>
            </div>

            <div class="col-12 col-md-4 py-1">
              <v-text-field
                  v-model="BirthCertificateNo"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  :label="$getText('NUMBER-OF-CERTIFICATE')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-12 col-md-4 py-1">
              <v-text-field
                  v-model="NationalCode"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  :label="$getText('CERTIFICATE_CODE')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-12 col-md-4 py-1">
              <v-text-field
                  v-model="Religion"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  :label="$getText('RELIGION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-12 col-md-4 py-1">
              <v-text-field
                  v-model="Nationality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  :label="$getText('NATIONALITY')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-12 col-md-4 py-1">
              <v-text-field
                  v-model="BirthPlace"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class="text-fied-input"
                  color="acent"

                  :label="$getText('CITY_OF_BIRTH')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-12 col-md-4 py-1 d-flex justify-space-between">
              <v-autocomplete
                  v-model="BirthDay"
                  :items="dayItems"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""
                  item-text="text"
                  item-value="id"
                  :label="$getText('BIRTHDAY')"
                  outlined>
              </v-autocomplete>
              <v-autocomplete
                  v-model="BirthMonth"
                  :items="monthItems"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class="mx-1  "
                  color=""

                  item-text="text"
                  item-value="id"
                  :label="$getText('BIRTH_MONTH')"
                  outlined>
              </v-autocomplete>
              <v-autocomplete
                  v-model="BirthYear"
                  :items="yearItems"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  :label="$getText('YEAR_OF_BIRTH')"
                  outlined>
              </v-autocomplete>
            </div>
            <div class="col-12 col-md-4 py-1">
              <v-radio-group
                  v-model="Single"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  color=""

                  row>
                <v-radio
                    color=""
                    :label="$getText('SINGLE')"
                    value="false"
                ></v-radio>
                <v-radio
                    color=""
                    :label="$getText('MARRIED')"
                    value="true"
                ></v-radio>
              </v-radio-group>
            </div>


          </div>
        </fieldset>
        <fieldset class="field-border p-2 my-5 ">
          <legend class="col-auto px-2 legend-text primary-color-text text-center">{{$getText("EDUCATION_AND_TRAINING_RECORDS")}}</legend>
          <div class="row mx-0 primary-border pt-4">
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalCertificateTitle1"
                  class=""
                  color=""
                  :label="$getText('DEGREE OF EDUCATION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalBranch1"
                  class=""
                  color=""
                  :label="$getText('MAJOR')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalAvg1"
                  class=""
                  color=""
                  :label="$getText('TOTAL_AVERAGE')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="EducationalStartDate1Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="EducationalStartDate1"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""
                      :label=" $getText('START_DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="EducationalStartDate1Date"
                    color="black"
                    locale="fa-ir"
                    width="256"
                    @input="EducationalStartDate1Input">

                </v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="EducationalEndDate1Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="EducationalEndDate1"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label="$getText('END-DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="EducationalEndDate1Date"
                    color="black"
                    locale="fa-ir"
                    width="256"
                    @input="EducationalEndDate1Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalCenterTitle1"
                  class=""
                  color=""

                  :label="$getText('NAME_OF_EDUCATIONAL_INSTITUTION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalCenterCity1"
                  class=""
                  color=""

                  :label="$getText('CITY_OF_EDUCATION')"
                  outlined>
              </v-text-field>
            </div>
            <div v-if="!showEducation2" class="col-12">
              <v-btn class="pb-1 black--text"
                     color="" @click="showEducation2 = true">
                {{ $getText("ADD_OTHER_EDUCATIONAL_BACKGROUND") }}
                <i class="fas fa-plus mr-2"></i>
              </v-btn>
            </div>
          </div>
          <div v-if="showEducation2" class="row mx-0 my-5 primary-border pt-4">
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalCertificateTitle2"
                  class=""
                  color=""

                  :label="$getText('DEGREE OF EDUCATION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalBranch2"
                  class=""
                  color=""

                  :label="$getText('MAJOR')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalAvg2"
                  class=""
                  color=""

                  :label="$getText('TOTAL_AVERAGE')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="EducationalStartDate2Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="EducationalStartDate2"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label=" $getText('START_DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="EducationalStartDate2Date"
                    color="black"
                    locale="fa-ir"
                    width="256"
                    @input="EducationalStartDate2Input">

                </v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="EducationalEndDate2Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="EducationalEndDate2"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label="$getText('END-DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="EducationalEndDate2Date"
                    color="black"
                    locale="fa-ir"
                    width="256"
                    @input="EducationalEndDate2Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalCenterTitle2"
                  class=""
                  color=""

                  :label="$getText('NAME_OF_EDUCATIONAL_INSTITUTION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalCenterCity2"
                  class=""
                  color=""

                  :label="$getText('CITY_OF_EDUCATION')"
                  outlined>
              </v-text-field>
            </div>
            <div v-if="!showEducation3" class="col-12">
              <v-btn class="pb-1 black--text"
                     color="" @click="showEducation3 = true">
                {{ $getText("ADD_OTHER_EDUCATIONAL_BACKGROUND") }}
                <i class="fas fa-plus mr-2"></i>
              </v-btn>
            </div>
          </div>
          <div v-if="showEducation3" class="row mx-0 primary-border pt-4">
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalCertificateTitle3"
                  class=""
                  color=""

                  :label="$getText('DEGREE OF EDUCATION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalBranch3"
                  class=""
                  color=""

                  :label="$getText('MAJOR')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalAvg3"
                  class=""
                  color=""

                  :label="$getText('TOTAL_AVERAGE')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="EducationalStartDate3Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="EducationalStartDate3"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label=" $getText('END-DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="EducationalStartDate3Date"
                    color="black"                    locale="fa-ir"
                    width="256"
                    @input="EducationalStartDate3Input"></v-date-picker>
              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="EducationalEndDate3Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="EducationalEndDate3"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label="$getText('END-DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="EducationalEndDate3Date"
                    color="black"
                    locale="fa-ir"
                    width="256"
                    @input="EducationalEndDate3Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="EducationalCenterTitle3"
                  class=""
                  color=""
                  :label="$getText('NAME_OF_EDUCATIONAL_INSTITUTION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1 ">
              <v-text-field
                  v-model="EducationalCenterCity3"
                  class=""
                  color=""

                  :label="$getText('CITY_OF_EDUCATION')"
                  outlined>
              </v-text-field>
            </div>
          </div>
        </fieldset>
        <fieldset class="field-border p-2 my-5">
          <legend class="col-auto px-2 legend-text primary-color-text text-center">{{$getText("JOB_EXPERIENCE")}}</legend>
          <div class="row mx-0 primary-border pt-4">
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceCompany1"
                  class=""
                  color=""

                  :label="$getText('ORGANIZATION_OR_COMPANY_NAME')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperiencePosition1"
                  class=""
                  color=""

                  :label="$getText('POSITION-OCCUPATION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceDuration1"
                  class=""
                  color=""

                  :label="$getText('HISTORY-PERIOD')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="WorkExperienceStartDate1Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="WorkExperienceStartDate1"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label="$getText('START_DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="WorkExperienceStartDate1Date"
                    color="black"                    locale="fa-ir"
                    width="256"
                    @input="WorkExperienceStartDate1Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="WorkExperienceEndDate1Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="WorkExperienceEndDate1"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label="$getText('END-DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="WorkExperienceEndDate1Date"
                    color="black"
                    locale="fa-ir"
                    width="256"
                    @input="WorkExperienceEndDate1Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceSalary1"
                  class=""
                  color=""

                  :label="$getText('LATEST_SALARY_AND_BENEFITS')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceLeaveReason1"
                  class=""
                  color=""

                  :label="$getText('REASON_FOR_LEAVING_SERVICE')"
                  outlined>
              </v-text-field>
            </div>
            <div v-if="!showWorkExperience2" class="col-12">
              <v-btn class="pb-1 black--text"
                     color="" @click="showWorkExperience2 = true">
                {{ $getText("ADD_OTHER_EDUCATIONAL_BACKGROUND") }}
                <i class="fas fa-plus mr-2"></i>
              </v-btn>
            </div>
          </div>
          <div v-if="showWorkExperience2" class="row mx-0 primary-border pt-4 my-4">
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceCompany2"
                  class=""
                  color=""
                  :label="$getText('ORGANIZATION_OR_COMPANY_NAME')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperiencePosition2"
                  class=""
                  color=""

                  :label="$getText('POSITION-OCCUPATION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceDuration2"
                  class=""
                  color=""

                  :label="$getText('HISTORY-PERIOD')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="WorkExperienceStartDate2Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="WorkExperienceStartDate2"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label=" $getText('START_DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="WorkExperienceStartDate2Date"
                    color="black"
                    locale="fa-ir"
                    width="256"
                    @input="WorkExperienceStartDate2Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="WorkExperienceEndDate2Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="WorkExperienceEndDate2"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label="$getText('END-DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="WorkExperienceEndDate2Date"
                    color="black"

                    locale="fa-ir"
                    width="256"
                    @input="WorkExperienceEndDate2Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceSalary2"
                  class=""
                  color=""

                  :label="$getText('LATEST_SALARY_AND_BENEFITS')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceLeaveReason2"
                  class=""
                  color=""

                  :label="$getText('REASON_FOR_LEAVING_SERVICE')"
                  outlined>
              </v-text-field>
            </div>
            <div v-if="!showWorkExperience3" class="col-12">
              <v-btn class="pb-1 black--text"
                     color="" @click="showWorkExperience3 = true">
                {{ $getText("ADD_OTHER_EDUCATIONAL_BACKGROUND") }}
                <i class="fas fa-plus mr-2"></i>
              </v-btn>
            </div>
          </div>
          <div v-if="showWorkExperience3" class="row mx-0 primary-border pt-4 mb-4">
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceCompany3"
                  class=""
                  color=""

                  :label="$getText('ORGANIZATION_OR_COMPANY_NAME')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperiencePosition3"
                  class=""
                  color=""

                  :label="$getText('POSITION-OCCUPATION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceDuration3"
                  class=""
                  color=""

                  :label="$getText('HISTORY-PERIOD')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="WorkExperienceStartDate3Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="WorkExperienceStartDate3"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label=" $getText('START_DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="WorkExperienceStartDate3Date"
                    color="black"
                    locale="fa-ir"
                    width="256"
                    @input="WorkExperienceStartDate3Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="WorkExperienceEndDate3Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="WorkExperienceEndDate3"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label="$getText('END-DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="WorkExperienceEndDate3Date"
                    color="black"

                    locale="fa-ir"
                    width="256"
                    @input="WorkExperienceEndDate3Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceSalary3"
                  class=""
                  color=""

                  :label="$getText('LATEST_SALARY_AND_BENEFITS')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceLeaveReason3"
                  class=""
                  color=""

                  :label="$getText('REASON_FOR_LEAVING_SERVICE')"
                  outlined>
              </v-text-field>
            </div>
            <div v-if="!showWorkExperience4" class="col-12">
              <v-btn class="pb-1 black--text"
                     color="" @click="showWorkExperience4 = true">
                {{ $getText("ADD_OTHER_EDUCATIONAL_BACKGROUND") }}
                <i class="fas fa-plus mr-2"></i>
              </v-btn>
            </div>
          </div>
          <div v-if="showWorkExperience4" class="row mx-0 primary-border pt-4">
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceCompany4"
                  class=""
                  color=""
                  :label="$getText('ORGANIZATION_OR_COMPANY_NAME')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperiencePosition4"
                  class=""
                  color=""

                  :label="$getText('POSITION-OCCUPATION')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceDuration4"
                  class=""
                  color=""

                  :label="$getText('HISTORY-PERIOD')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="WorkExperienceStartDate4Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="WorkExperienceStartDate4"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label=" $getText('START_DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="WorkExperienceStartDate4Date"
                    color="black"
                    locale="fa-ir"
                    width="256"
                    @input="WorkExperienceStartDate4Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-menu
                  v-model="WorkExperienceEndDate4Menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="auto"
                  offset-y
                  transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="WorkExperienceEndDate4"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="fas fa-calendar-alt"
                      class=""
                      color=""

                      :label="$getText('END-DATE')"
                      outlined>
                  </v-text-field>
                </template>
                <v-date-picker
                    v-model="WorkExperienceEndDate4Date"
                    color="black"

                    locale="fa-ir"
                    width="256"
                    @input="WorkExperienceEndDate4Input"></v-date-picker>

              </v-menu>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceSalary4"
                  class=""
                  color=""

                  :label="$getText('LATEST_SALARY_AND_BENEFITS')"
                  outlined>
              </v-text-field>
            </div>
            <div class="col-md p-1">
              <v-text-field
                  v-model="WorkExperienceLeaveReason4"
                  class=""
                  color=""

                  :label="$getText('REASON_FOR_LEAVING_SERVICE')"
                  outlined>
              </v-text-field>
            </div>
          </div>
          <div class="col-12 primary-text">
            <div class="row">
              <div class="col-md-6 align-self-center">
                {{$getText("INSURANCE_PREMIUM_PAYMENT_HISTORY")}}
              </div>
              <div class=" col-6 col-md-3">
                <v-text-field
                    v-model="InsuranceYear"
                    class=""
                    color=""

                    hide-details
                    :label="$getText('YEAR')"
                    outlined>
                </v-text-field>
              </div>
              <div class=" col-6 col-md-3">
                <v-text-field
                    v-model="InsuranceMonth"
                    class=""
                    color=""

                    hide-details
                    :label="$getText('MONTH')"
                    outlined>
                </v-text-field>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset class="field-border p-2 my-5">
          <legend class="col-auto px-2 legend-text primary-color-text text-center">{{ $getText("FAMILIARITY_WITH_FOREIGN_LANGUAGES")}}</legend>
          <div class="row mx-0">
            <div class="col-md-6">
              <fieldset class="field-border p-2 my-5">
                <legend class="col-auto px-2 legend-text text-center">{{ $getText("ENGLISH_LANGUAGE")}}</legend>
                <div class="row mx-0">
                  <div class="col-12 col-md-6">
                    <v-autocomplete
                        v-model="EnglishSpeaking"
                        :items="TypeQuality"
                        class=""
                        color=""

                        hide-details
                        item-text="text"
                        item-value="id"
                        :label="$getText('READ')"
                        outlined>
                    </v-autocomplete>
                  </div>
                  <div class="col-12 col-md-6">
                    <v-autocomplete
                        v-model="EnglishWriting"
                        :items="TypeQuality"
                        class=""
                        color=""

                        hide-details
                        item-text="text"
                        item-value="id"
                        :label="$getText('WRITE')"
                        outlined>
                    </v-autocomplete>
                  </div>
                  <div class="col-12 col-md-6">
                    <v-autocomplete
                        v-model="EnglishReading"
                        :items="TypeQuality"
                        class=""
                        color=""

                        hide-details
                        item-text="text"
                        item-value="id"
                        :label="$getText('CALL')"
                        outlined>
                    </v-autocomplete>
                  </div>
                  <div class="col-12 col-md-6">
                    <v-autocomplete
                        v-model="EnglishListening"
                        :items="TypeQuality"
                        class=""
                        color=""

                        hide-details
                        item-text="text"
                        item-value="id"
                        :label="$getText('LISTENING')"
                        outlined>
                    </v-autocomplete>

                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-md-6">
              <fieldset class="field-border p-2 my-5">
                <legend class="col-auto px-2 legend-text text-center">{{ $getText("ANOTHER_LANGUAGE")}}</legend>
                <div class="row mx-0">
                  <div class="col-12">
                    <v-text-field
                        v-model="OtherLanguageTitle"
                        class=""
                        color=""

                        hide-details
                        :label="$getText('TITLE')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6">
                    <v-autocomplete
                        v-model="OtherLanguageSpeaking"
                        :items="TypeQuality"
                        class=""
                        color=""

                        hide-details
                        item-text="text"
                        item-value="id"
                        :label="$getText('READ')"
                        outlined>
                    </v-autocomplete>
                  </div>
                  <div class="col-md-6">
                    <v-autocomplete
                        v-model="OtherLanguageWriting"
                        :items="TypeQuality"
                        class=""
                        color=""

                        hide-details
                        item-text="text"
                        item-value="id"
                        :label="$getText('WRITE')"
                        outlined>
                    </v-autocomplete>
                  </div>
                  <div class="col-md-6">
                    <v-autocomplete
                        v-model="OtherLanguageReading"
                        :items="TypeQuality"
                        class=""
                        color=""

                        hide-details
                        item-text="text"
                        item-value="id"
                        :label="$getText('CALL')"
                        outlined>
                    </v-autocomplete>
                  </div>
                  <div class="col-md-6">
                    <v-autocomplete
                        v-model="OtherLanguageListening"
                        :items="TypeQuality"
                        class=""
                        color=""

                        hide-details
                        item-text="text"
                        item-value="id"
                        :label="$getText('LISTENING')"
                        outlined>
                    </v-autocomplete>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </fieldset>
        <fieldset class="field-border p-2 my-5" >
          <legend class="col-auto col-auto px-2 legend-text primary-color-text text-center">{{$getText("COMPUTER_FAMILIARITY")}}</legend>
          <div class="row mx-0">
            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="HTML"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="HTML"
                  outlined>
              </v-autocomplete>
            </div>
            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="CSS"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="CSS"
                  outlined>
              </v-autocomplete>
            </div>

            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="JavaScript"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="JavaScript"
                  outlined>
              </v-autocomplete>
            </div>

            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="jQuery"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="jQuery"
                  outlined>
              </v-autocomplete>
            </div>
            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="BootStrap"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="BootStrap"
                  outlined>
              </v-autocomplete>
            </div>
            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="VueJs"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="VueJs"
                  outlined>
              </v-autocomplete>
            </div>
            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="CSharp"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="CSharp"
                  outlined>
              </v-autocomplete>
            </div>
            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="SQL"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="SQL"
                  outlined>
              </v-autocomplete>
            </div>
            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="PhotoShop"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="PhotoShop"
                  outlined>
              </v-autocomplete>
            </div>
            <div class="col-6 col-md-4 col-lg-3">
              <v-autocomplete
                  v-model="InternetSearch"
                  :items="TypeQuality"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  item-text="text"
                  item-value="id"
                  label="InternetSearch"
                  outlined>
              </v-autocomplete>
            </div>
          </div>
        </fieldset>
        <fieldset class="field-border p-2 my-5">
          <legend class="col-auto px-2 legend-text primary-color-text text-center"> {{$getText("COOPERATION")}}</legend>
          <div class="row mx-0">
            <div class="col-md-6">
              <v-radio-group
                  v-model="TypeCooperation"
                  class="text-align"
                  color=""
                  column

                  :label="$getText('WILLINGNESS_TO_COOPERATE')">
                <v-radio
                    color=""
                    :label="$getText('FULL_TIME')"
                    value="1"
                ></v-radio>
                <v-radio
                    color=""
                    :label="$getText('PART_TIME')"
                    value="2"
                ></v-radio>
                <v-radio
                    color=""
                    :label="$getText('TELECOMMUTING')"
                    value="3"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="col-12 col-md-6">
              <v-radio-group
                  v-model="WorkingCurrently"
                  class="text-align"
                  color=""
                  column

                  :label="$getText('ARE_YOU_WORKING_NOW')"
              >
                <v-radio
                    color=""
                    :label="$getText('YES')"
                    value="true"
                ></v-radio>
                <v-radio
                    color=""
                    :label="$getText('NO')"
                    value="false"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="col-12 col-md-6">
              <v-radio-group
                  v-model="WorkingGuarantee"
                  class="text-align"
                  color=""
                  column

                  :label="$getText('GUARANTEE')"
              >
                <v-radio
                    color=""
                    :label="$getText('YES')"
                    value="true"
                ></v-radio>
                <v-radio
                    color=""
                    :label="$getText('NO')"
                    value="false"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="col-12 col-md-6 ">
              <v-radio-group
                  v-model="MinimumSalary"
                  class="text-align"
                  color=""
                  column

                  :label="$getText('EXPECTED_SALARY')"
              >
                <v-radio
                    color=""
                    :label="$getText('ACCORDING_TO_COMPANY_RULES')"
                    :value="$getText('ACCORDING_TO_COMPANY_RULES')"
                ></v-radio>
                <div class="row">
                  <v-radio
                      class="col-4 mt-3"
                      color=""
                      :label="$getText('SUGGESTED_AMOUNT')"
                      value="true"
                  ></v-radio>
                  <v-text-field
                      v-if="MinimumSalary === 'true'"
                      v-model="minSalary"
                      class=" col-8"
                      color=""

                      hide-details
                      :label="$getText('MINIMUM_AMOUNT')"

                      outlined>
                  </v-text-field>
                </div>
              </v-radio-group>
            </div>
            <div class="col-12 col-md-6">
              <v-radio-group
                  v-model="AcceptRemoteCityWork"
                  class="text-align"
                  color=""
                  column

                  :label="$getText('TRANSFER_OR_MISSION')"
              >
                <v-radio
                    color=""
                    :label="$getText('YES')"
                    value="true"
                ></v-radio>
                <v-radio
                    color=""
                    :label="$getText('NO')"
                    value="false"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="col-12 col-md-6">
              <v-textarea
                  v-model="SkillAndOthersDesc"
                  class="text-area-field"
                  color=""

                  :label="$getText('ABILITY')"
                  outlined
                  rows="5">
              </v-textarea>
            </div>
          </div>
        </fieldset>
        <fieldset class="field-border p-2 my-5">
          <legend class="col-auto px-2 legend-text primary-color-text text-center">{{$getText("FAMILY") }}</legend>
          <div class="row">
            <div class="col-md-6">
              <fieldset class="field-border p-2 my-5">
                <legend class="col-auto px-2 legend-text text-center">{{$getText("FIRST_PERSON") }}</legend>
                <div class="row mx-0">
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoName1"
                        class=""
                        color=""

                        :label= "$getText('FULL_NAME')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoIsMale1"
                        class=""
                        color=""

                        :label="$getText('GENDER')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoRelation1"
                        class=""
                        color=""

                        :label="$getText('RELATIVE_TO_YOU')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoJob1"
                        class=""
                        color=""

                        :label="$getText('POSITION-OCCUPATION')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoEducation1"
                        class=""
                        color=""

                        :label="$getText('LEVEL_OF_EDUCATION')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoPhone1"
                        class=""
                        color=""

                        :label="$getText('PHONE_NUMBER')"
                        outlined>
                    </v-text-field>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-md-6">
              <fieldset class="field-border p-2 my-5">
                <legend class="col-auto px-2 legend-text text-center">{{$getText("SECOND_PERSON") }}</legend>
                <div class="row mx-0">
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoName2"
                        class=""
                        color=""

                        :label= "$getText('FULL_NAME')"
                        outlined>
                    </v-text-field>
                  </div>

                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoIsMale2"
                        class=""
                        color=""

                        :label="$getText('GENDER')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoRelation2"
                        class=""
                        color=""

                        :label="$getText('RELATIVE_TO_YOU')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoJob2"
                        class=""
                        color=""

                        :label="$getText('POSITION-OCCUPATION')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoEducation2"
                        class=""
                        color=""

                        :label="$getText('LEVEL_OF_EDUCATION')"
                        outlined>
                    </v-text-field>
                  </div>
                  <div class="col-md-6 col-lg-4 p-1">
                    <v-text-field
                        v-model="FamilyInfoPhone2"
                        class=""
                        color=""

                        :label="$getText('PHONE_NUMBER')"
                        outlined>
                    </v-text-field>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

        </fieldset>
        <fieldset class="field-border p-2 my-5">
          <legend class="col-auto px-2 legend-text primary-color-text text-center">{{$getText("TRANSLATION") }}</legend>
          <div class="row mx-0">
            <div class="col-12 pt-0">
              <p class=" text-left mt-2">
                The resolution, or sharpness, of a picture is determined by the number of pixels it has. More pixels
                improve the resolution of a picture, which allows you to make a larger print without reducing visual
                quality. Keep in mind, however, that the more pixels a picture has, the larger its file size will be
              </p>
              <v-textarea
                  v-model="Translation"
                  class="text-area-field"
                  color=""

                  :label="$getText('TRANSLATE')"
                  outlined
                  rows="5">
              </v-textarea>
            </div>
          </div>
        </fieldset>
        <fieldset class="field-border p-2 my-5">
          <legend class="col-auto px-2 legend-text primary-color-text text-center">{{$getText("YOUR_PLACE") }}</legend>
          <div class="row mx-0">
            <div class="col-12 pt-0">
              <v-textarea
                  v-model="Address"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class="text-area-field"
                  color=""

                  :label="$getText('YOUR_PLACE')"
                  outlined
                  rows="5">
              </v-textarea>
            </div>
            <div class="col-12 pt-0">
              <v-text-field
                  v-model="Phone"
                  :rules="[v => !!v || this.$getText('MANDATORY_FIELD')]"
                  class=""
                  color=""

                  :label="$getText('PHONE_CALL')"
                  outlined>
              </v-text-field>
            </div>
          </div>
        </fieldset>
        <div class="row">
          <div class="col-6 mx-auto text-center">
            <v-btn block color="" @click="register">
              {{$getText("SUBMIT") }}
            </v-btn>
          </div>
        </div>

      </v-form>
      <v-overlay
          id="searchOverLay"
          :absolute="false"
          :color="'#636363'"
          :opacity="0.7"
          :value="showLoaderDialog"
          :z-index="6">
        <div class="row h-100 align-items-center justify-content-center">
          <div class="loading-spinner">
          </div>
        </div>
      </v-overlay>
      <v-dialog
          v-model="showResultDialog"

          hide-overlay
          persistent
          width="500">
        <v-card class="text-center">
          <v-card-title class="justify-space-between primary">
            <i class="fas fa-times-circle shadow-lg font19px pointer" @click="showResultDialog = false"></i>
          </v-card-title>
          <v-card-text class="pt-6">
            <div class="mb-0  py-5">{{ dialogResult }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showSuccessResultDialog"

          hide-overlay
          persistent
          width="500">
        <v-card class="text-center">
          <v-card-title class="justify-space-between primary">

          </v-card-title>
          <v-card-text class="pt-6">
            <div class="mb-0 white--text py-5">{{ dialogResult }}</div>
          </v-card-text>
          <v-card-actions class="justify-content-center">
            <v-btn color="" to="/">
              تایید
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <footer-pages></footer-pages>
  </div>
</template>

<script>

import moment from "moment-jalaali";
import NavBar from "@/components/NavBar";
import FooterPages from "@/components/FooterPages";


export default {
  name: "workWithUs",
  metaInfo: {
    title: 'ایزیسیس طراحی وب سایت اپلیکیشن موبایل و استارت اپ-همکاری با ما'
  },
  components: {FooterPages, NavBar},

  data: () => ({

    FamilyInfoEducationalBranch:'',
    FamilyInfoEducationalBranch2:'',
    showSuccessResultDialog: false,
    showLoaderDialog: false,
    dialogResult: '',
    showResultDialog: false,
    title: 'استخدام',
    NameAndFamily: '',
    FatherName: '',
    BirthPlace: '',
    BirthCertificateNo: '',
    NationalCode: '',
    Religion: '',
    Nationality: null,
    BirthDay: null,
    BirthMonth: null,
    BirthYear: null,
    dayItems: [],
    monthItems: [],
    yearItems: [],
    Single: null,
    EducationalCertificateTitle1: '',
    EducationalBranch1: '',
    EducationalAvg1: '',
    EducationalStartDate1: '',
    EducationalEndDate1: '',
    EducationalCenterTitle1: '',
    EducationalCenterCountry1: '',
    EducationalCenterCity1: '',
    EducationalCertificateTitle2: '',
    EducationalBranch2: '',
    EducationalAvg2: '',
    EducationalStartDate2: '',
    EducationalEndDate2: '',
    EducationalCenterTitle2: '',
    EducationalCenterCountry2: '',
    EducationalCenterCity2: '',
    EducationalCertificateTitle3: '',
    EducationalBranch3: '',
    EducationalAvg3: '',
    EducationalStartDate3: '',
    EducationalEndDate3: '',
    EducationalCenterTitle3: '',
    EducationalCenterCountry3: '',
    EducationalCenterCity3: '',
    showEducation2: false,
    showEducation3: false,
    EducationalStartDate1Menu: false,
    EducationalStartDate1Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    EducationalEndDate1Menu: false,
    EducationalEndDate1Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    EducationalStartDate2Menu: false,
    EducationalStartDate2Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    EducationalEndDate2Menu: false,
    EducationalEndDate2Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    EducationalStartDate3Menu: false,
    EducationalStartDate3Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    EducationalEndDate3Menu: false,
    EducationalEndDate3Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    WorkExperienceCompany1: '',
    WorkExperiencePosition1: '',
    WorkExperienceDuration1: '',
    WorkExperienceStartDate1Menu: false,
    WorkExperienceStartDate1Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    WorkExperienceStartDate1: '',
    WorkExperienceEndDate1Menu: false,
    WorkExperienceEndDate1Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    WorkExperienceEndDate1: '',
    WorkExperienceSalary1: '',
    WorkExperienceLeaveReason1: '',
    showWorkExperience2: false,
    showWorkExperience3: false,
    showWorkExperience4: false,
    WorkExperienceCompany2: '',
    WorkExperiencePosition2: '',
    WorkExperienceDuration2: '',
    WorkExperienceStartDate2Menu: false,
    WorkExperienceStartDate2Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    WorkExperienceStartDate2: '',
    WorkExperienceEndDate2Menu: false,
    WorkExperienceEndDate2Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    WorkExperienceEndDate2: '',
    WorkExperienceSalary2: '',
    WorkExperienceLeaveReason2: '',
    WorkExperienceCompany3: '',
    WorkExperiencePosition3: '',
    WorkExperienceDuration3: '',
    WorkExperienceStartDate3Menu: false,
    WorkExperienceStartDate3Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    WorkExperienceStartDate3: '',
    WorkExperienceEndDate3Menu: false,
    WorkExperienceEndDate3Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    WorkExperienceEndDate3: '',
    WorkExperienceSalary3: '',
    WorkExperienceLeaveReason3: '',
    WorkExperienceCompany4: '',
    WorkExperiencePosition4: '',
    WorkExperienceDuration4: '',
    WorkExperienceStartDate4Menu: false,
    WorkExperienceStartDate4Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    WorkExperienceStartDate4: '',
    WorkExperienceEndDate4Menu: false,
    WorkExperienceEndDate4Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    WorkExperienceEndDate4: '',
    WorkExperienceSalary4: '',
    WorkExperienceLeaveReason4: '',
    InsuranceYear: '',
    InsuranceMonth: '',
    TypeQuality: [],
    EnglishSpeaking: null,
    EnglishWriting: null,
    EnglishReading: null,
    EnglishListening: null,
    OtherLanguageSpeaking: null,
    OtherLanguageWriting: null,
    OtherLanguageReading: null,
    OtherLanguageListening: null,
    OtherLanguageTitle: null,
    HTML: null,
    CSS: null,
    JavaScript: null,
    jQuery: null,
    BootStrap: null,
    VueJs: null,
    CSharp: null,
    SQL: null,
    PhotoShop: null,
    InternetSearch: null,
    TypeCooperation: null,
    TypeCooperationItems: [
      {id: 1, text: 'تمام وقت'},
      {id: 2, text: 'پاره وقت'},
      {id: 3, text: 'دورکاری'},
    ],
    WorkingCurrently: null,
    WorkingGuarantee: null,
    MinimumSalary: null,
    minSalary: null,
    AcceptRemoteCityWork: null,
    FamilyInfoName1: '',
    FamilyInfoIsMale1: '',
    FamilyInfoRelation1: '',
    FamilyInfoJob1: '',
    FamilyInfoEducation1: '',
    FamilyInfoPhone1: '',
    FamilyInfoName2: '',
    FamilyInfoIsMale2: '',
    FamilyInfoRelation2: '',
    FamilyInfoJob2: '',
    FamilyInfoEducation2: '',
    FamilyInfoPhone2: '',
    SkillAndOthersDesc: '',
    Address: '',
    Phone: '',
    Translation: '',

  }),
  mounted() {
    this.initBirthItems()
    this.$setCssFiles()

    this.TypeQuality =
        [
            {id: 1, text: this.$getText("UNFAMILIARITY")},
            {id: 2, text: this.$getText("WEAK")},
            {id: 3, text: this.$getText("MEDIUM")},
            {id: 4, text: this.$getText("GOOD")},
            {id: 5, text: this.$getText("VERY_GOOD")}
        ]
  },
  methods: {

    initBirthItems() {
      let days = []
      for (let i = 1; i <= 31; i++) {
        days.push({id: i, text: i})
      }
      this.dayItems = days
      let months = []
      for (let i = 1; i <= 12; i++) {
        months.push({id: i, text: i})
      }
      this.monthItems = months
      let years = []
      for (let i = 1385; i >= 1355; i--) {
        years.push({id: i, text: i})
      }
      this.yearItems = years
    },
    EducationalStartDate1Input() {
      this.EducationalStartDate1Menu = false
      this.EducationalStartDate1 = moment(this.EducationalStartDate1Date).format('jYYYY/jMM/jDD')
    },
    EducationalEndDate1Input() {
      this.EducationalEndDate1Menu = false
      this.EducationalEndDate1 = moment(this.EducationalEndDate1Date).format('jYYYY/jMM/jDD')
    },
    EducationalStartDate2Input() {
      this.EducationalStartDate2Menu = false
      this.EducationalStartDate2 = moment(this.EducationalStartDate2Date).format('jYYYY/jMM/jDD')
    },
    EducationalEndDate2Input() {
      this.EducationalEndDate2Menu = false
      this.EducationalEndDate2 = moment(this.EducationalEndDate2Date).format('jYYYY/jMM/jDD')
    },
    EducationalStartDate3Input() {
      this.EducationalStartDate3Menu = false
      this.EducationalStartDate3 = moment(this.EducationalStartDate3Date).format('jYYYY/jMM/jDD')
    },
    EducationalEndDate3Input() {
      this.EducationalEndDate3Menu = false
      this.EducationalEndDate3 = moment(this.EducationalEndDate3Date).format('jYYYY/jMM/jDD')
    },
    WorkExperienceStartDate1Input() {
      this.WorkExperienceStartDate1Menu = false
      this.WorkExperienceStartDate1 = moment(this.WorkExperienceStartDate1Date).format('jYYYY/jMM/jDD')
    },
    WorkExperienceEndDate1Input() {
      this.WorkExperienceEndDate1Menu = false
      this.WorkExperienceEndDate1 = moment(this.WorkExperienceEndDate1Date).format('jYYYY/jMM/jDD')
    },
    WorkExperienceStartDate2Input() {
      this.WorkExperienceStartDate2Menu = false
      this.WorkExperienceStartDate2 = moment(this.WorkExperienceStartDate2Date).format('jYYYY/jMM/jDD')
    },
    WorkExperienceEndDate2Input() {
      this.WorkExperienceEndDate2Menu = false
      this.WorkExperienceEndDate2 = moment(this.WorkExperienceEndDate2Date).format('jYYYY/jMM/jDD')
    },
    WorkExperienceStartDate3Input() {
      this.WorkExperienceStartDate3Menu = false
      this.WorkExperienceStartDate3 = moment(this.WorkExperienceStartDate3Date).format('jYYYY/jMM/jDD')
    },
    WorkExperienceEndDate3Input() {
      this.WorkExperienceEndDate3Menu = false
      this.WorkExperienceEndDate3 = moment(this.WorkExperienceEndDate3Date).format('jYYYY/jMM/jDD')
    },
    WorkExperienceStartDate4Input() {
      this.WorkExperienceStartDate4Menu = false
      this.WorkExperienceStartDate4 = moment(this.WorkExperienceStartDate4Date).format('jYYYY/jMM/jDD')
    },
    WorkExperienceEndDate4Input() {
      this.WorkExperienceEndDate4Menu = false
      this.WorkExperienceEndDate4 = moment(this.WorkExperienceEndDate4Date).format('jYYYY/jMM/jDD')
    },
    register() {
      this.$refs.form.validate()

      if (this.$refs.form.validate()) {
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();

        urlencoded.append("NameAndFamily", this.NameAndFamily);
        urlencoded.append("FatherName", this.FatherName);
        urlencoded.append("BirthPlace", this.BirthPlace);
        urlencoded.append("BirthYear", this.BirthYear);
        urlencoded.append("BirthMonth", this.BirthMonth);
        urlencoded.append("BirthDay", this.BirthDay);
        urlencoded.append("BirthCertificateNo", this.BirthCertificateNo);
        urlencoded.append("NationalCode", this.NationalCode);
        urlencoded.append("Religion", this.Religion);
        urlencoded.append("Nationality", this.Nationality);
        urlencoded.append("Single", this.Single);
        if (this.EducationalCertificateTitle1 !== '') {
          urlencoded.append("EducationalCertificateTitle1", this.EducationalCertificateTitle1);
        }
        if (this.EducationalCertificateTitle2 !== '') {
          urlencoded.append("EducationalCertificateTitle2", this.EducationalCertificateTitle2);
        }
        if (this.EducationalCertificateTitle3 !== '') {
          urlencoded.append("EducationalCertificateTitle3", this.EducationalCertificateTitle3);
        }
        if (this.EducationalBranch1 !== '') {
          urlencoded.append("EducationalBranch1", this.EducationalBranch1);
        }
        if (this.EducationalBranch2 !== '') {
          urlencoded.append("EducationalBranch2", this.EducationalBranch2);
        }
        if (this.EducationalBranch3 !== '') {

          urlencoded.append("EducationalBranch3", this.EducationalBranch3);
        }
        if (this.EducationalAvg1 !== '') {

          urlencoded.append("EducationalAvg1", this.EducationalAvg1);
        }
        if (this.EducationalAvg2 !== '') {

          urlencoded.append("EducationalAvg2", this.EducationalAvg2);
        }
        if (this.EducationalAvg3 !== '') {

          urlencoded.append("EducationalAvg3", this.EducationalAvg3);
        }
        if (this.EducationalStartDate1 !== '') {

          urlencoded.append("EducationalStartDate1", this.EducationalStartDate1);
        }
        if (this.EducationalStartDate2 !== '') {

          urlencoded.append("EducationalStartDate2", this.EducationalStartDate2);
        }
        if (this.EducationalStartDate3 !== '') {

          urlencoded.append("EducationalStartDate3", this.EducationalStartDate3);
        }
        if (this.EducationalEndDate1 !== '') {

          urlencoded.append("EducationalEndDate1", this.EducationalEndDate1);
        }
        if (this.EducationalEndDate2 !== '') {

          urlencoded.append("EducationalEndDate2", this.EducationalEndDate2);
        }
        if (this.EducationalEndDate3 !== '') {

          urlencoded.append("EducationalEndDate3", this.EducationalEndDate3);
        }
        if (this.EducationalCenterTitle1 !== '') {

          urlencoded.append("EducationalCenterTitle1", this.EducationalCenterTitle1);
        }
        if (this.EducationalCenterTitle2 !== '') {

          urlencoded.append("EducationalCenterTitle2", this.EducationalCenterTitle2);
        }
        if (this.EducationalCenterTitle3 !== '') {

          urlencoded.append("EducationalCenterTitle3", this.EducationalCenterTitle3);
        }
        urlencoded.append("EducationalCenterCountry1", this.EducationalCenterCountry1);
        urlencoded.append("EducationalCenterCountry2", this.EducationalCenterCountry2);
        urlencoded.append("EducationalCenterCountry3", this.EducationalCenterCountry3);
        if (this.EducationalCenterCity1 !== '') {

          urlencoded.append("EducationalCenterCity1", this.EducationalCenterCity1);
        }
        if (this.EducationalCenterCity2 !== '') {

          urlencoded.append("EducationalCenterCity2", this.EducationalCenterCity2);
        }
        if (this.EducationalCenterCity3 !== '') {

          urlencoded.append("EducationalCenterCity3", this.EducationalCenterCity3);
        }
        if (this.WorkExperienceCompany1 !== '') {
          urlencoded.append("WorkExperienceCompany1", this.WorkExperienceCompany1);
        }
        if (this.WorkExperienceCompany2 !== '') {

          urlencoded.append("WorkExperienceCompany2", this.WorkExperienceCompany2);
        }
        if (this.WorkExperienceCompany3 !== '') {

          urlencoded.append("WorkExperienceCompany3", this.WorkExperienceCompany3);
        }
        if (this.WorkExperienceCompany4 !== '') {

          urlencoded.append("WorkExperienceCompany4", this.WorkExperienceCompany4);
        }
        if (this.WorkExperiencePosition1 !== '') {

          urlencoded.append("WorkExperiencePosition1", this.WorkExperiencePosition1);
        }
        if (this.WorkExperiencePosition2 !== '') {

          urlencoded.append("WorkExperiencePosition2", this.WorkExperiencePosition2);
        }
        if (this.WorkExperiencePosition3 !== '') {

          urlencoded.append("WorkExperiencePosition3", this.WorkExperiencePosition3);
        }
        if (this.WorkExperiencePosition4 !== '') {

          urlencoded.append("WorkExperiencePosition4", this.WorkExperiencePosition4);
        }
        if (this.WorkExperienceDuration1 !== '') {

          urlencoded.append("WorkExperienceDuration1", this.WorkExperienceDuration1);
        }
        if (this.WorkExperienceDuration2 !== '') {

          urlencoded.append("WorkExperienceDuration2", this.WorkExperienceDuration2);
        }
        if (this.WorkExperienceDuration3 !== '') {

          urlencoded.append("WorkExperienceDuration3", this.WorkExperienceDuration3);
        }
        if (this.WorkExperienceDuration4 !== '') {

          urlencoded.append("WorkExperienceDuration4", this.WorkExperienceDuration4);
        }
        if (this.WorkExperienceStartDate1 !== '') {

          urlencoded.append("WorkExperienceStartDate1", this.WorkExperienceStartDate1);
        }
        if (this.WorkExperienceStartDate2 !== '') {

          urlencoded.append("WorkExperienceStartDate2", this.WorkExperienceStartDate2);
        }
        if (this.WorkExperienceStartDate3 !== '') {

          urlencoded.append("WorkExperienceStartDate3", this.WorkExperienceStartDate3);
        }
        if (this.WorkExperienceStartDate4 !== '') {

          urlencoded.append("WorkExperienceStartDate4", this.WorkExperienceStartDate4);
        }
        if (this.WorkExperienceEndDate1 !== '') {

          urlencoded.append("WorkExperienceEndDate1", this.WorkExperienceEndDate1);
        }
        if (this.WorkExperienceEndDate2 !== '') {

          urlencoded.append("WorkExperienceEndDate2", this.WorkExperienceEndDate2);
        }
        if (this.WorkExperienceEndDate3 !== '') {

          urlencoded.append("WorkExperienceEndDate3", this.WorkExperienceEndDate3);
        }
        if (this.WorkExperienceEndDate4 !== '') {

          urlencoded.append("WorkExperienceEndDate4", this.WorkExperienceEndDate4);
        }
        if (this.WorkExperienceSalary1 !== '') {

          urlencoded.append("WorkExperienceSalary1", this.WorkExperienceSalary1);
        }
        if (this.WorkExperienceSalary2 !== '') {

          urlencoded.append("WorkExperienceSalary2", this.WorkExperienceSalary2);
        }
        if (this.WorkExperienceSalary3 !== '') {

          urlencoded.append("WorkExperienceSalary3", this.WorkExperienceSalary3);
        }
        if (this.WorkExperienceSalary4 !== '') {

          urlencoded.append("WorkExperienceSalary4", this.WorkExperienceSalary4);
        }
        if (this.WorkExperienceLeaveReason1 !== '') {

          urlencoded.append("WorkExperienceLeaveReason1", this.WorkExperienceLeaveReason1);
        }
        if (this.WorkExperienceLeaveReason2 !== '') {

          urlencoded.append("WorkExperienceLeaveReason2", this.WorkExperienceLeaveReason2);
        }
        if (this.WorkExperienceLeaveReason3 !== '') {

          urlencoded.append("WorkExperienceLeaveReason3", this.WorkExperienceLeaveReason3);
        }
        if (this.WorkExperienceLeaveReason4 !== '') {

          urlencoded.append("WorkExperienceLeaveReason4", this.WorkExperienceLeaveReason4);
        }
        if (this.InsuranceYear !== '') {

          urlencoded.append("InsuranceYear", this.InsuranceYear);
        }
        if (this.InsuranceMonth !== '') {

          urlencoded.append("InsuranceMonth", this.InsuranceMonth);
        }
        if (this.EnglishSpeaking !== null) {
          urlencoded.append("EnglishSpeaking", this.EnglishSpeaking);
        }
        if (this.EnglishWriting !== null) {
          urlencoded.append("EnglishWriting", this.EnglishWriting);
        }
        if (this.EnglishReading !== null) {
          urlencoded.append("EnglishReading", this.EnglishReading);
        }
        if (this.EnglishListening !== null) {
          urlencoded.append("EnglishListening", this.EnglishListening);
        }
        if (this.OtherLanguageTitle !== '') {

          urlencoded.append("OtherLanguageTitle", this.OtherLanguageTitle);
        }
        if (this.OtherLanguageSpeaking !== null) {
          urlencoded.append("OtherLanguageSpeaking", this.OtherLanguageSpeaking);
        }
        if (this.OtherLanguageWriting !== null) {
          urlencoded.append("OtherLanguageWriting", this.OtherLanguageWriting);
        }
        if (this.OtherLanguageReading !== null) {
          urlencoded.append("OtherLanguageReading", this.OtherLanguageReading);
        }
        if (this.OtherLanguageListening !== null) {
          urlencoded.append("OtherLanguageListening", this.OtherLanguageListening);
        }
        urlencoded.append("HTML", this.HTML);
        urlencoded.append("CSS", this.CSS);
        urlencoded.append("JavaScript", this.JavaScript);
        urlencoded.append("jQuery", this.jQuery);
        urlencoded.append("BootStrap", this.BootStrap);
        urlencoded.append("VueJs", this.VueJs);
        urlencoded.append("CSharp", this.CSharp);
        urlencoded.append("SQL", this.SQL);
        urlencoded.append("PhotoShop", this.PhotoShop);
        urlencoded.append("InternetSearch", this.InternetSearch);
        if (this.TypeCooperation !== null) {
          urlencoded.append("TypeCooperation", this.TypeCooperation);
        }
        if (this.WorkingCurrently !== null) {
          urlencoded.append("WorkingCurrently", this.WorkingCurrently);
        }
        if (this.WorkingGuarantee !== null) {
          urlencoded.append("WorkingGuarantee", this.WorkingGuarantee);
        }
        if (this.SkillAndOthersDesc !== '') {

          urlencoded.append("SkillAndOthersDesc", this.SkillAndOthersDesc);
        }
        if (this.MinimumSalary === 'true') {
          urlencoded.append("MinimumSalary", this.minSalary);
        } else if (this.MinimumSalary !== null) {
          urlencoded.append("MinimumSalary", this.MinimumSalary);
        }
        if (this.AcceptRemoteCityWork !== null) {
          urlencoded.append("AcceptRemoteCityWork", this.AcceptRemoteCityWork);
        }
        if (this.FamilyInfoName1 !== '') {

          urlencoded.append("FamilyInfoName1", this.FamilyInfoName1);
        }
        if (this.FamilyInfoName2 !== '') {

          urlencoded.append("FamilyInfoName2", this.FamilyInfoName2);
        }
        if (this.FamilyInfoIsMale1 !== '') {

          urlencoded.append("FamilyInfoIsMale1", this.FamilyInfoIsMale1);
        }
        if (this.FamilyInfoIsMale2 !== '') {

          urlencoded.append("FamilyInfoIsMale2", this.FamilyInfoIsMale2);
        }
        if (this.FamilyInfoRelation1 !== '') {

          urlencoded.append("FamilyInfoRelation1", this.FamilyInfoRelation1);
        }
        if (this.FamilyInfoRelation2 !== '') {

          urlencoded.append("FamilyInfoRelation2", this.FamilyInfoRelation2);
        }
        if (this.FamilyInfoJob1 !== '') {

          urlencoded.append("FamilyInfoJob1", this.FamilyInfoJob1);
        }
        if (this.FamilyInfoJob2 !== '') {

          urlencoded.append("FamilyInfoJob2", this.FamilyInfoJob2);
        }
        if (this.FamilyInfoEducation1 !== '') {

          urlencoded.append("FamilyInfoEducation1", this.FamilyInfoEducation1);
        }
        if (this.FamilyInfoEducation2 !== '') {

          urlencoded.append("FamilyInfoEducation2", this.FamilyInfoEducation2);
        }
        if (this.FamilyInfoPhone1 !== '') {

          urlencoded.append("FamilyInfoPhone1", this.FamilyInfoPhone1);
        }
        if (this.FamilyInfoPhone2 !== '') {

          urlencoded.append("FamilyInfoPhone2", this.FamilyInfoPhone2);
        }
        if (this.Translation !== '') {

          urlencoded.append("Translation", this.Translation);
        }

        urlencoded.append("Address", this.Address);
        urlencoded.append("Phone", this.Phone);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        let resStatus = null

        fetch(this.$BaseUrl + "Api/SubmitCv", requestOptions)
            .then(response => {
              resStatus=response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if(resStatus ===200){
                this.showSuccessResultDialog=true
              }else {
                this.showResultDialog = true
              }
              this.dialogResult = result

            })
            .catch(error => console.log('error', error));
      } else {
        this.dialogResult = this.$getText("COMPLETE_THE_FIELDS")
        this.showResultDialog = true
      }

    }
  }
}
</script>

<style scoped>
.bg-gray{
  background-color: #d2d2d2;
}
</style>
